import styled from 'styled-components';
import { CLOSE_MODAL_ICON } from 'assets/icons';
import { DEVICES } from '_constants';
import { UiColors } from 'assets/styles/old/global';

export const ModalWrapper = styled.div`
  position: absolute;
  top: 54px;
  right: 5px;
  width: 400px;
  height: auto;
  max-height: calc(100vh - 108px);
  /* 5px with the flag off — see --popover-radius in base.scss. */
  border-radius: var(--popover-radius);
  border: 1px solid var(--grey);
  background: white;
  color: ${UiColors.forestColor};
  overflow: auto;

  @media ${DEVICES.mobileXL} {
    width: 100vw;
  }
`;
export const List = styled.ul``;

export const ListItem = styled.li`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  padding: 20px;

  :hover {
    background: #ffe3d3;
    cursor: pointer;
  }
`;

export const ReadCircle = styled.div`
  min-height: 8px;
  min-width: 8px;
  border-radius: 50%;
  background: ${({ hasReadCircle }) => (hasReadCircle ? UiColors.forestColor : 'transparent')};
  margin-right: 15px;
`;

export const ItemText = styled.span``;

export const CancelIconWrapper = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 2;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: var(--dark);
  background: transparent url(${CLOSE_MODAL_ICON}) no-repeat center center;
  padding: 0;
  border: none;

  /* Same treatment as the modal frame's close button (ui-kit/Modal): CLOSE_MODAL_ICON is an SVG
     file with its fill baked in, so it cannot be recoloured. The redesign drops the image and draws
     the cross from two pseudo-element bars in currentColor, which takes the panel's forest text.
     html[...] rather than :root[...] — stylis auto-prefixes a selector that opens with a
     pseudo-class, which would compile to ".generatedClass:root[...]" and never match. */
  html[data-new-ui='true'] & {
    background-image: none;
    border-radius: 8px;
    color: inherit;
    transition: background 0.15s ease;

    &:hover {
      background-color: var(--lite-grey);
    }

    &::before,
    &::after {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      width: 15px;
      height: 2px;
      margin: -1px 0 0 -7.5px;
      border-radius: 1px;
      background: currentColor;
    }

    &::before {
      transform: rotate(45deg);
    }

    &::after {
      transform: rotate(-45deg);
    }
  }
`;

export const ModalTitle = styled.h2`
  padding: 20px 40px;
  font-size: 22px;
  font-weight: 500;
`;
